import {
  DELETE_SDK_APPLICATION_SUCCESS,
  GET_ALL_SDK_APPLICATIONS_SUCCESS,
  LOGOUT_COMPLETE,
} from 'js/constants/actionTypes';

const initialState = {
  sortedIds: [],
  lastUpdated: null,
};

export const sdkApplicationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_SDK_APPLICATIONS_SUCCESS:
      return saveSdkApplications(state, action);

    case DELETE_SDK_APPLICATION_SUCCESS:
      return deleteSdkApplication(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

function saveSdkApplications(state, action) {
  const { entities } = action;
  const { sdkApplications = {} } = entities;

  const descOrderIds = Object.values(sdkApplications)
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map((i) => i.id);

  return {
    ...state,
    sortedIds: descOrderIds,
    lastUpdated: action.receivedAt,
  };
}

function deleteSdkApplication(state, action) {
  const {
    requestInfo: { id: deletedId },
  } = action;
  const { sortedIds } = state;
  const newSortedIds = sortedIds.filter((id) => id !== deletedId);

  return {
    ...state,
    lastUpdated: action.receivedAt,
    sortedIds: newSortedIds,
  };
}
